// InvitePage.js
import {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {validateInviteToken} from '../../api/UserManagementService';
import AurBanner from '../common/aur-banner/AurBanner';
import AurLoadingIndicator from '../common/aur-loading-indicator/AurLoadingIndictor';
import {t} from 'i18next';
import {auroraLauchPointUrl} from '../../config';

const InvitePage = () => {
  const location = useLocation(); // Get the location object
  const queryParams = new URLSearchParams(location.search); // Parse the query parameters
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showDisplayMessage, setShowDisplayMessage] = useState<boolean>(false);

  const token = queryParams.get('token'); // Get the 'token' query parameter

  const validateToken = async (token: string) => {
    setIsLoading(true);
    try {
      const response: any = await validateInviteToken(token);
      await response.data;
      window.open(auroraLauchPointUrl, '_self');
    } catch (error: any) {
      if (error.status !== 200) {
        setShowDisplayMessage(true);
        setTimeout(() => {
          navigate('/login');
          setShowDisplayMessage(false);
        }, 5000);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      validateToken(token);
    }
  }, [token]);

  return (
    <div>
      {<AurLoadingIndicator overlay={true} isOpen={isLoading} />}
      {showDisplayMessage && (
        <div className="invite-page-message">
          <AurBanner
            errorText={t('error.invitationInvalidOrExpired')}
            errorType="error"
          />
        </div>
      )}
    </div>
  );
};

export default InvitePage;
